import { getIsFeatureEnabled } from '@app/utils/getIsFeatureEnabled';
import { useAmplitude } from '@app/utils/hooks';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import { compiledPaths } from '../../../paths';
import { Breadcrumb, Breadcrumbs } from '../../various/Breadcrumbs';

interface Props {
  lookbookId: string;
  isProductsPage?: boolean;
  isWishlistPage?: boolean;
  isCmsPage?: boolean;
}
export const LookbookTopBar = ({ isProductsPage = false, isWishlistPage = false, isCmsPage = false, lookbookId }: Props) => {
  const { t } = useTranslation(['lookbook', 'products']);
  const { trackEvent } = useAmplitude();
  const isWishlistEnabled = getIsFeatureEnabled('ENABLE_LOOKBOOK_WISHLIST');

  const steps: Breadcrumb[] = [
    {
      dataTestId: 'lookbookProductsStep',
      isSelected: isProductsPage,
      label: t('products:all_products'),
      onClick: () => {
        trackEvent({ name: 'breadcrumbs.link.lookbook.click', properties: { context: isCmsPage ? 'cms' : 'lookbook' } });
      },
      to: compiledPaths.LOOKBOOK_SINGLE({ lookbookId }),
    },
    ...(isWishlistEnabled ?
      [
        {
          dataTestId: 'wishlistStep',
          isSelected: isWishlistPage,
          label: t('lookbook:wishlist'),
          onClick: () => {
            trackEvent({ name: 'breadcrumbs.link.wishlist.click', properties: { context: isCmsPage ? 'cms' : 'lookbook' } });
          },
          to: compiledPaths.LOOKBOOK_WISHLIST_PAGE({ lookbookId }),
        },
      ]
    : []),
  ];

  return (
    <div
      className={cx(
        'sticky top-[--headerWithBannerHeight] z-topBar flex w-full items-center justify-between bg-neutral-96 py-3 transition-[top] group-[.scrollingDown]/body:top-0 lg:top-[--headerWithBannerHeightOnDesktop]',
        {
          'px-4 pb-3 lg:px-8': isWishlistPage,
          'px-4 sm:px-4 lg:px-8': isProductsPage,
          'top-[6.5rem] px-4 lg:top-[7.5rem] lg:px-8': isCmsPage,
        },
      )}
    >
      <Breadcrumbs steps={steps} title={t('lookbook:lookbook_steps')} />
    </div>
  );
};
